import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FetchDataService } from 'src/app/shared/services/fetch-data.service';
@Component({
  selector: 'app-work-counter',

  templateUrl: './work-counter.component.html',
  styleUrls: ['./work-counter.component.css'],
})
export class WorkCounterComponent {
  @Input() data!:any;
  @Input() fileName!: string;  
  @Input() language!: string;

  constructor() {}
  
    
}
